import React, { useEffect, useState } from "react";
import "../assets/css/Panel.css";
import Navbar from "../components/Navbar";
import {api} from "../utils/gashtaltAPI";
import ErrorPage from "../components/ErrorPage";
import Loader from "../components/Loader";
import {Table, TableContainer, Tbody, Td, Thead, Tr, useDisclosure} from "@chakra-ui/react";
import {toPersianNumber} from "../utils/numberConversion";
import DiscountModal from "../components/DiscountModal";
import {toast} from "react-toastify";
import TableToolbar from "../components/TableToolbar";
import Pagination from "../components/Pagination";
import EmptyState from "../components/EmptyState";

function Discounts() {
  const [discounts, setDiscounts] = useState([]);
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading,setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setRefresh(false)
      try {
        const response = await api.get(`/api/discounts?page=${currentPage}`);
        setDiscounts(response.data.data);
        setCurrentPage(response.data.current_page);
        setStartIndex(response.data.from);
        setLastPage(response.data.last_page);
        setTotal(response.data.total);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    if(refresh)
      fetchData();
  }, [currentPage,refresh]);

  const toggleStatus = async (discountId) =>{
    setLoading(true)
    try {
      const response = await api.post(`/api/discount/toggle/${discountId}`);
      setDiscounts((prevDiscounts) =>
          prevDiscounts.map((discount, i) => ({
            ...discount,
            status: discount.id === discountId ? (response.data.active ? 1 : 0) : discount.status,
          }))
      );
      toast.success(response.data.message, {
        position: "bottom-right",
      });
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status !== 500) {
          toast.error(error.response.data.message, {
            position: "bottom-right",
          });
        }
        return;
      } else if (error.request) {
        toast.error("اتصال اینترنت خود را بررسی کنید!", {
          position: "bottom-right",
        });
        return;
      }
      toast.error("خطایی رخ داد!", {
        position: "bottom-right",
      });
    }finally {
      setLoading(false)
    }
  }
  if (loading) return <Loader />
  if (error) return <ErrorPage error={error} />;
  return (
    <div className="d-flex flex-column h-100">
      <Navbar />
      <div className="admin-page flex-fill">
        <TableToolbar title="کدهای تخفیف" count={total}>
          <button className="btn btn-outline-orange d-flex align-items-center gap-1" onClick={onOpen}>
            <i className="bi bi-plus-lg"></i>
            افزودن کد تخفیف
          </button>
        </TableToolbar>

        <div className="admin-table-card">
          <TableContainer>
            <Table variant="striped" colorScheme="teal">
              <Thead>
                <Tr>
                  <Td>ردیف</Td>
                  <Td>کد تخفیف</Td>
                  <Td>محصول</Td>
                  <Td>مبلغ</Td>
                  <Td>وضعیت</Td>
                </Tr>
              </Thead>
              <Tbody>
                {discounts.map((discount, index) => (
                    <Tr key={discount.id}>
                      <Td>{toPersianNumber(startIndex+index)}</Td>
                      <Td style={{direction:'ltr',textAlign:'end'}}>{toPersianNumber(discount.code)}</Td>
                      <Td>{toPersianNumber(discount.product_name)}</Td>
                      <Td>
                        {toPersianNumber(discount.discount_amount)}%
                        {discount.product_id !== 0 &&
                            ` (${toPersianNumber(discount.product_price*discount.discount_amount/100)} تومان)`}
                      </Td>
                      <Td>
                        <button
                            className={`status-pill ${discount.status === 1 ? "is-on" : "is-off"}`}
                            title="برای تغییر وضعیت کلیک کنید"
                            onClick={() => {
                              toggleStatus(discount.id);
                            }}
                        >
                          <span className="status-dot"></span>
                          {discount.status == 1 ? "فعال" : "غیرفعال"}
                        </button>
                      </Td>
                    </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
          {discounts.length === 0 && <EmptyState text="کد تخفیفی ثبت نشده است." />}
        </div>

        <Pagination currentPage={currentPage} lastPage={lastPage} onChange={setCurrentPage} />

        <DiscountModal isOpen={isOpen} onClose={onClose} setRefresh={setRefresh}/>
      </div>
    </div>
  );
}

export default Discounts;
